export default "__VITE_ASSET__DKyHYITg__"